import { z } from "zod/v4";

import { createEndpointBase } from "./core";

const base = "auth";
const oauth = createEndpointBase(base);

export const oauthEndpoints = {
  oauthAuthenticate: oauth({
    method: "GET",
    path: ":id",
    request: z.any(),
    response: z.any(),
    description: "Redirects to the OAuth authentication service.",
  }),
  oauthRedirect: oauth({
    method: "GET",
    path: ":id/redirect",
    request: z.any(),
    response: z.any(),
    description: "Handles the OAuth redirect and returns an authentication token.",
  }),
  oauthRefresh: oauth({
    method: "GET",
    path: ":id/refresh",
    request: z.any(),
    response: z.any(),
    description: "Refreshes the OAuth authentication token.",
  }),
} as const;
